import styled from 'styled-components';

export const StyledCreateWorkflowModal = styled.div`
  width: 100%;

  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
`;
